import script from "./CardUrlUnirse.vue?vue&type=script&setup=true&lang=js"
export * from "./CardUrlUnirse.vue?vue&type=script&setup=true&lang=js"

import "./CardUrlUnirse.vue?vue&type=style&index=0&id=b08c13fe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b08c13fe"]])

export default __exports__